import type { OnyxComponentInputs, OnyxTableColumn } from '@onyx/angular';
import { AddressCellComponent } from '../../../../../common/components/cells/address-cell/address-cell.component';
import type { BaseAssignedDriversFormGroup } from '../../base-form/base-assigned-drivers-form/base-assigned-drivers-form.component';
import { BaseDriverCellComponent } from '../cells/base-driver-cell/base-driver-cell.component';

export const BASE_ASSIGNED_DRIVERS_FORM_COLUMNS: OnyxTableColumn<BaseAssignedDriversFormGroup>[] =
  [
    {
      id: 'driver',
      name: 'labels.driver',
      width: 'fill',
      component: {
        ref: BaseDriverCellComponent,
        inputs: (data): OnyxComponentInputs<BaseDriverCellComponent> => ({
          driver: data.item.getRawValue().driver,
        }),
      },
    },
    {
      id: 'address',
      name: 'labels.address',
      width: '370px',
      component: {
        ref: AddressCellComponent,
        inputs: (data): OnyxComponentInputs<AddressCellComponent> => ({
          address: data.item.getRawValue().driver.driverData.homeAddress,
          format: 'short',
        }),
      },
    },
  ];
